import _ from 'lodash'

import { SpecimenResource } from '@skinsoft/types'
import { EntityDataStore } from '@skinsoft/entity-data-store'
import { SEARCH_TYPES } from '@skinsoft/const'
import { SpecimenOfflineDataFetcher, SpecimenOfflineDataUpdateCacher } from '@skinsoft/offline'

export class SpecimenDataStore extends EntityDataStore<SpecimenResource, any, SpecimenResource> {
    public static getInstance() {
        if (!SpecimenDataStore.instance) {
            SpecimenDataStore.instance = new SpecimenDataStore();
        }

        return SpecimenDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$specimenDataStore = SpecimenDataStore.getInstance();
    }

    private static instance: SpecimenDataStore = null as any

    constructor() {
        super('specimens', [SEARCH_TYPES.specimen])
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new SpecimenOfflineDataFetcher()
    }

    protected initializeDataPusher() {
        this.offlineDataUpdateCacher = new SpecimenOfflineDataUpdateCacher()
    }
}